import { SIDEBAR_CONSTANTS } from "./sidebarConstants";

export const CALENDAR_CONSTANTS = {
  ADD_EIGHT_HOUR: 8 * 60 * 60 * 1000,
  BIG_CALENDAR_LANGUAGE: "en-GB",
  CALANDER_TYPES: [
    { value: "jobs", route: SIDEBAR_CONSTANTS.ROUTE_JOB },
    {
      value: "assignment",
      route: SIDEBAR_CONSTANTS.ROUTE_PROFESSIONAL_USERS,
    },
  ],
  CALANDER_TYPES_OPTIONS: {
    JOBS: "jobs",
    OFFICE: "office",
    PROFESSIONAL: "assignment",
    NOTES_CALENDER: "notes",
  },
  CALANDER_VIEW_TYPES: {
    CALANDER: "calander",
    LIST: "list",
  },
  CALANDER_FROM_JOB_MODULE: "jobs",
  CALENDAR_LANGUAGE: "en-US",
  DAYS: "days",
  DAY: "day",
  DAY_CELL_MIN_PIXEL: 7,
  DAY_INDEX: 1,
  DAY_EVENT_MIN_TOP: 90,
  DAY_EVENT_CELL_WIDTH: 95,
  DEFAULT_CONTRACT_DAY_WIDTH: "2280px",
  DEFAULT_TIME: ":00",
  EMPTY: "",
  FILTER_RESET_TYPE: "reset",
  FIND_FILTER: {
    CITY: "city",
    DATE: "date",
    ID: "uuid",
    JOB_ID: "job_id",
    NAME: "name",
    NAME_PROFESSIONAL: "professional_name",
    OFFICE_NAME: "office_name",
    STATE: "state",
    ZIP: "zip_code",
  },
  FIRST_DAY: 0,
  GOTO_BACK_NAV: "back",
  GOTO_NEXT_NAV: "next",
  HEIGHT_PER_EVENT: 90,
  HEIGHT_PER_EVENT_WEEK: 77,
  INITIAL_POINT_INDEX: 0,
  JOB_CATEGORY_KEY: "job_categories",
  CATEGORY_PROFESSIONAL: "category_professional",
  JOIN_ARRAY: ",",
  LONG_PRESS_THRESHOLD: 10,
  MONTH: "month",
  MONTHS: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  MORE_THAN_ONE_POINT: 0,
  NEXT: "next",
  OVERFLOW_MIN_LENGTH: 50,
  NOT_END_TIME: "",
  PER_DAY: 1,
  PER_MONTH: 1,
  POINT_TO_SHOW: 2,
  POINT_TO_SHOW_WEB: 2,
  PREVIOUS: "prev",
  PROFESSIONAL_CALANDER: {
    FIELDS: {
      EMAIL: "email",
      ROLE: "position",
    },
  },
  SATURDAY_INDEX: 6,
  SPACE: " ",
  WEB_SIZE: 1200,
  WEEK: "week",
  WEEK_DAYS: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  WEEK_DAYS_COUNT: 7,
  WEEKDAY_SHORT: "short",
  WINDOW_RESIZE: "resize",
};
